<template>
  <div class="modal">
    <div class="modal-window bg-light_gray">
      <div v-if="closeModal" class="btn-close">
        <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" @click="closeModal"><g fill-rule="evenodd"><rect height="1" rx=".5" transform="matrix(.70710678 .70710678 -.70710678 .70710678 10.010408 -4.146447)" width="16" x="2.010408" y="9.510408"/><rect height="1" rx=".5" transform="matrix(.70710678 -.70710678 .70710678 .70710678 -4.146447 10.010408)" width="16" x="2.010408" y="9.510408"/></g></svg>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    closeModal: {
      type: Function
    }
  }
}
</script>
